import {
  SIGN_IN_CODE_RATE_LIMITED_MESSAGE,
  UNDELIVERABLE_EMAIL_MESSAGE,
} from "@convex/constants/signInCodeRefusals";
import { track } from "@/lib/analytics/tracker";
import type { AuthEntryPoint, AuthFailureStage, AuthMethod } from "@/lib/analytics/types";
import { validationErrorMessage } from "@convex/errors";
import type { SignInErrorReason } from "./result";

export type AuthFailureReason =
  | SignInErrorReason
  | "needs_hosted"
  | "exception"
  | "undeliverable"
  | "send_failed"
  | "request_failed";

export interface AuthAttempt {
  entryPoint: AuthEntryPoint;
  method: AuthMethod;
}

export function trackAuthFailure(
  attempt: AuthAttempt,
  stage: AuthFailureStage,
  reason: AuthFailureReason,
): void {
  track("auth.failed", {
    entry_point: attempt.entryPoint,
    method: attempt.method,
    stage,
    reason,
  });
}

export function trackAuthCompleted(attempt: AuthAttempt, isNew: boolean): void {
  track("auth.completed", { entry_point: attempt.entryPoint, method: attempt.method, is_new: isNew });
}

export function sendFailureReason(cause: unknown): AuthFailureReason {
  const message = validationErrorMessage(cause);
  if (message === SIGN_IN_CODE_RATE_LIMITED_MESSAGE) return "rate_limited";
  if (message === UNDELIVERABLE_EMAIL_MESSAGE) return "undeliverable";
  return message === null ? "send_failed" : "invalid_input";
}
